import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

var canSearch = true;

//Module过滤器触发
export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  let searchParameter = { ...sectionComponent.state.searchParameter };
  searchParameter.moduleId = parameter;
  sectionComponent.setState({ searchParameter, componentDefaultValue });
  pageComponent.setState({ module: sectionComponent.state.componentDataSource[uie.source].filter(c => c.Value === parameter)[0].Key, moduleId: parameter });
  setTimeout(() => {
    getDocumentTypeDataSource({ sectionName: sectionName, parameter: parameter, sectionComponent: sectionComponent, pageComponent: pageComponent });
    getLgaDataSource({ sectionName: sectionName, parameter: parameter, sectionComponent: sectionComponent, pageComponent: pageComponent });
    getJobTypeDataSource({ sectionName: sectionName, parameter: parameter, sectionComponent: sectionComponent, pageComponent: pageComponent });
    getRegionDataSource({ sectionName: sectionName, parameter: parameter, sectionComponent: sectionComponent, pageComponent: pageComponent });
    if (canSearch && sectionComponent.state.searchParameter.moduleId != undefined && sectionComponent.state.searchParameter.dataModelType != undefined) {
      sectionComponent.getSectionDataByDefault();
      canSearch = false;
      setTimeout(() => {
        canSearch = true;
      }, 100);
    }
  }, config.setTimeoutMilliSecond);
}

//DataModelType过滤器触发
export function getSectionDataByDataModelType({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  let searchParameter = { ...sectionComponent.state.searchParameter };
  searchParameter.dataModelType = parameter;
  sectionComponent.setState({ searchParameter, componentDefaultValue });
  pageComponent.setState({ dataModelTypeName: sectionComponent.state.componentDataSource[uie.source].filter(c => c.Value === parameter)[0].Key, dataModelType: parameter });
  setTimeout(() => {
    if (canSearch && sectionComponent.state.searchParameter.moduleId != undefined && sectionComponent.state.searchParameter.dataModelType != undefined) {
      sectionComponent.getSectionDataByDefault();
      canSearch = false;
      setTimeout(() => {
        canSearch = true;
      }, 100);
    }
  }, config.setTimeoutMilliSecond);
}

//点击添加按钮
export function addBySection({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ currentDataKey: null, fileList: [] });
  if (pageComponent.state.componentDataSource.DocumentTypeId != undefined &&
    pageComponent.state.componentDataSource.AutotaskAssigneeType != undefined &&
    pageComponent.state.componentDataSource.AutotaskTeamId != undefined) {
    pageComponent.setState({ showModal: true, customFormSubmitting: false, componentType: 'Create', title: 'Upload Mail Merge Template' });
    setTimeout(() => {
      pageComponent.formRef.current?.resetFields();
      pageComponent.formRef.current?.setFieldValue('DocumentTypeId', pageComponent.state.componentDataSource.DocumentTypeId[0].Value);
      pageComponent.formRef.current?.setFieldValue('AutotaskAssigneeType', pageComponent.state.componentDataSource.AutotaskAssigneeType[0].Value);
      pageComponent.formRef.current?.setFieldValue('AutotaskTeamId', pageComponent.state.componentDataSource.AutotaskTeamId[0].Value);
      pageComponent.formRef.current?.setFieldValue('LgaId', pageComponent.state.componentDataSource.LgaId[0].Value);
      pageComponent.formRef.current?.setFieldValue('CompanyOfficeId', pageComponent.state.componentDataSource.CompanyOfficeId[0].Value);
      pageComponent.formRef.current?.setFieldValue('file', undefined);
    }, config.setTimeoutMilliSecond);
  }
}

//点击添加按钮
export function addByGroup({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  addBySection({ sectionName: sectionName, parameter: parameter, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie });
  setTimeout(() => {
    if (parameter !== 'No Group') {
      pageComponent.formRef.current?.setFieldValue('GroupName', parameter);
    }
  }, config.setTimeoutMilliSecond);
}

//点击编辑按钮
export function editBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ showModal: true, customFormSubmitting: false, componentType: 'Edit', title: 'Edit Mail Merge Template' });
  httpClient
    .get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
    .then(({ data }) => {
      if (data.result) {
        //把处理后的数据赋值给表单
        if (data.data.DocumentTypeId === null && pageComponent.state.componentDataSource.DocumentTypeId !== undefined) {
          data.data.DocumentTypeId = pageComponent.state.componentDataSource.DocumentTypeId[0].Value;
        }
        if (data.data.AutotaskAssigneeType === null && pageComponent.state.componentDataSource.AutotaskAssigneeType !== undefined) {
          data.data.AutotaskAssigneeType = pageComponent.state.componentDataSource.AutotaskAssigneeType[0].Value;
        }
        if (data.data.AutotaskTeamId === null && pageComponent.state.componentDataSource.AutotaskTeamId !== undefined) {
          data.data.AutotaskTeamId = pageComponent.state.componentDataSource.AutotaskTeamId[0].Value;
        }
        if (data.data.LgaId === null && pageComponent.state.componentDataSource.LgaId !== undefined) {
          data.data.LgaId = pageComponent.state.componentDataSource.LgaId[0].Value;
        }
        if (data.data.CompanyOfficeId === null && pageComponent.state.componentDataSource.CompanyOfficeId !== undefined) {
          data.data.CompanyOfficeId = pageComponent.state.componentDataSource.CompanyOfficeId[0].Value;
        }
        data.data.file = undefined;
        pageComponent.formRef.current?.setFieldsValue(data.data);
        pageComponent.setState({ currentDataKey: data.data.key, fileList: [] });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//获取下拉菜单数据源
export function getDocumentTypeDataSource({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .get('/Admin/DocumentType/GetSelectOptionList?moduleId=' + pageComponent.state.moduleId)
    .then(({ data }) => {
      if (data.result) {
        if (data.data.length > 0) {
          let dataSource = data.data;
          let componentDataSource = { ...pageComponent.state.componentDataSource };
          componentDataSource.DocumentTypeId = dataSource;
          pageComponent.setState({ componentDataSource });
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function getAssigneeTypeDataSource({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .get('/System/SelectOption/GetAssigneeTypeList')
    .then(({ data }) => {
      if (data.result) {
        if (data.data.length > 0) {
          let dataSource = data.data;
          let componentDataSource = { ...pageComponent.state.componentDataSource };
          componentDataSource.AutotaskAssigneeType = dataSource;
          pageComponent.setState({ componentDataSource });
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function getTeamDataSource({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .get('/Admin/CompanyTeam/GetSelectOptionList')
    .then(({ data }) => {
      if (data.result) {
        if (data.data.length > 0) {
          let dataSource = data.data;
          let componentDataSource = { ...pageComponent.state.componentDataSource };
          componentDataSource.AutotaskTeamId = dataSource;
          pageComponent.setState({ componentDataSource });
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function getLgaDataSource({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .get('/Admin/Lga/GetSelectOptionList?moduleId=' + pageComponent.state.moduleId)
    .then(({ data }) => {
      if (data.result) {
        if (data.data.length > 0) {
          let dataSource = data.data;
          let componentDataSource = { ...pageComponent.state.componentDataSource };
          componentDataSource.LgaId = dataSource;
          pageComponent.setState({ componentDataSource });
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function getJobTypeDataSource({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .get('/Admin/JobType/GetSelectOptionList?moduleId=' + pageComponent.state.moduleId)
    .then(({ data }) => {
      if (data.result) {
        if (data.data.length > 0) {
          let dataSource = data.data.filter(item => item.Value !== 0);
          let componentDataSource = { ...pageComponent.state.componentDataSource };
          componentDataSource.JobTypeId = dataSource;
          pageComponent.setState({ componentDataSource });
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function getRegionDataSource({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .get('/Admin/Region/GetSelectOptionList?moduleId=' + pageComponent.state.moduleId)
    .then(({ data }) => {
      if (data.result) {
        if (data.data.length > 0) {
          let dataSource = data.data.filter(item => item.Value !== 0);
          let componentDataSource = { ...pageComponent.state.componentDataSource };
          componentDataSource.RegionId = dataSource;
          pageComponent.setState({ componentDataSource });
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function getCompanyOfficeDataSource({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .get('/Admin/CompanyOffice/GetSelectOptionList')
    .then(({ data }) => {
      if (data.result) {
        if (data.data.length > 0) {
          let dataSource = data.data;
          let componentDataSource = { ...pageComponent.state.componentDataSource };
          componentDataSource.CompanyOfficeId = dataSource;
          pageComponent.setState({ componentDataSource });
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function downloadMailMergeTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.download({ url: '/Admin/MailMergeTemplate/Download/' + parameter.key, data: null, filename: parameter.FileName });
}

// 行级右键菜单：打开 Mail Merge Template 版本历史
// 参数 sectionComponent 为 MailMergeTemplateTable 实例（在 Group 的 onRow.onContextMenu 中传入）
export function showMailMergeTemplateContextMenu({ e, parameter, sectionComponent, pageComponent } = {}) {
  sectionComponent.setState({
    event: e,
    mailMergeTemplateContextMenuShow: true,
    mailMergeTemplateId: parameter.MailMergeTemplateId,
    currentMailMergeTemplate: parameter
  });
  // 重置版本列表数据，避免显示上一次模板的版本
  sectionComponent.mailMergeTemplateVersion?.current?.setState({ data: [] });
  e.preventDefault();
  return false;
}
